<template>
  <div class="root">
    <div class="fixed top-0 left-0 right-0 bg-gray-100 z-40 shadow flex flex-col justify-center h-24">
      <div class="flex justify-center md:justify-between items-center w-full mx-auto lg:px-4">
        <div class="flex items-center">
          <img src="/images/Cardstock_Logo.png" class="w-32 md:w-48">
        </div>
        <div class="hidden md:block">
          <a class="underline pr-4 cursor-pointer text-yes-light-grey hover:text-yes-royal-blue" tabindex="0">
            See how it works</a>
          <a class="underline pr-4 cursor-pointer text-yes-light-grey hover:text-yes-royal-blue" tabindex="0">
            Pricing</a>
          <a class="underline pr-4 cursor-pointer text-yes-light-grey hover:text-yes-royal-blue" href="/app/teams" tabindex="0">
            Sign in</a>
          <a class="text-white py-2 px-4 rounded shadow-md cursor-pointer bg-cardstock-green-500 hover:bg-yes-green outline-none font-bold" tabindex="0">
            Start your trial now</a>
        </div>
      </div>
    </div>
    <div class="h-screen flex flex-col justify-center items-center">
      <div class="text-6xl mb-2">😢</div>
      <div class="text-2xl text-center mb-2">An unexpected error occurred</div>
      <div class="max-w-screen-sm mx-auto mt-8 p-4 bg-cardstock-yellow-400 rounded-lg leading-normal">
        <div class="font-bold text-xl">
          We're sorry
        </div>
        <div>
          An error occurred trying to load your page. This definitely <em>shouldn't</em> have happened, so an <a href="mailto:lanny.bose@cardstockforteachers.com?subject=Broken%20Cardstock%20Link" class="text-cardstock-blue-500 underline">email to let us know would be appreciated</a>.
        </div>
        <div class="mt-4">
          The following nerdy details might help us figure out what went wrong:
        </div>
        <div >
          <div class="font-mono text-xs border border-cardstock-yellow-500 bg-white mt-4 p-4 rounded">
            <div class="mb-4">
              Current User: {{userEmail}}
            </div>
            <div class="mb-4">
              Route: {{$route.fullPath}}
            </div>
            <div class="mb-4">
              Time: {{new Date}}
            </div>
            <div>
              Errors:
            </div>
            <div v-for="(error, index) in preloadErrors" :key="index">
              &nbsp;&nbsp;{{index + 1}}. {{error}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get'
import Container from '@/components/Container.vue'

export default {
  components: {
    Container
  },

  props: ['currentUser', 'preloadErrors'],

  data() {
    return {
      showNerdyDetails: false
    }
  },

  methods: {
    toggleNerdyDetails() {
      this.showNerdyDetails = !this.showNerdyDetails
    }
  },

  computed: {
    userEmail() {
      return _get(this, 'currentUser.email')
    }
  }
}
</script>
